import Vue from "vue";
import Vuex from "vuex";
import cloneDeep from "lodash/cloneDeep";
import user from "@/store/modules/user";
import versionControl from "@/store/modules/version.control";
import * as types from "@/common/vuex.const";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,versionControl
  },
  mutations: {
    [types.RESET_STATE]: state => {
      Object.keys(state).forEach(key => {
        state[key] = cloneDeep(window.SITE_CONFIG[types.STORE_STATE][key]);
      });
      localStorage.removeItem(types.LIFE_DATA);
    }
  },
  strict: process.env.NODE_ENV !== "production"
});
